import React, { useContext } from "react";
import SitesContext from "../context/sites.context";
import Constants from "../constants/Constants";
import { Link } from "@reach/router";
// import Loader from "./Loader";
//import { pretendModels } from "../pretendModels";

const ModelDirectory = () => {
  //const [isLoading, setIsLoading] = useState(true);
  const models = useContext(SitesContext);
  const orderedModelKeys = Object.keys(models).sort((a, b) => {
    const aMP = parseInt(models[a].mp);
    const bMP = parseInt(models[b].mp);
    if (aMP < bMP) {
      return 1;
    }
    if (aMP > bMP) {
      return -1;
    }
    return 0;
  });
  //const [models, setModels] = useState({});
  // useEffect(() => {
  //   setModels(pretendModels);
  //   setIsLoading(false);
  // }, []);
  // if (isLoading) {
  //   return <Loader />;
  // }
  return (
    <div className="thumbs">
      {orderedModelKeys.map((key) => {
        return (
          <div className="thumb" key={`m${models[key].id}`}>
            <Link to={`${Constants.MA}${models[key].site_url}`} className="th">
              <img
                src={`https://static.addfriends.com/images/friends/${models[key].site_url}.jpg`}
                alt={models[key].site_name}
              />
              <div className="inform">
                <div className="name">
                  <strong>{models[key].site_name.split(" ")[0]}</strong>{" "}
                  {models[key].site_name.split(" ")[1]
                    ? models[key].site_name.split(" ")[1]
                    : ""}
                </div>
                <div className="tags">
                  {models[key].tags.map((tag) => tag.hash_tag).join(", ")}
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
};

export default ModelDirectory;
